var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 108,
    viewBox: "0 0 110 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0095 0C39.2951 0 26.4494 12.6122 26.4494 28.0409C26.4494 43.4695 39.2951 56.0817 55.0095 56.0817C70.7239 56.0817 83.5696 43.4695 83.5696 28.0409C83.5696 12.6122 70.7239 0 55.0095 0Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.022 78.4899C103.273 76.6531 102.276 74.9388 101.153 73.347C95.4164 65.0203 86.5617 59.5102 76.5844 58.1632C75.3373 58.0409 73.9654 58.2856 72.9676 59.0203C67.7294 62.8163 61.4937 64.7754 55.0083 64.7754C48.5229 64.7754 42.2872 62.8163 37.049 59.0203C36.0512 58.2856 34.6793 57.9183 33.4323 58.1632C23.4549 59.5102 14.4754 65.0203 8.86321 73.347C7.74077 74.9388 6.74295 76.7756 5.99481 78.4899C5.62074 79.2246 5.74535 80.0817 6.11942 80.8165C7.11725 82.5307 8.3643 84.2452 9.48674 85.7145C11.2327 88.0411 13.1035 90.1226 15.2238 92.0817C16.9697 93.7959 18.9652 95.3878 20.9608 96.9797C30.8133 104.204 42.6615 108 54.8837 108C67.1059 108 78.9541 104.204 88.8066 96.9797C90.802 95.5104 92.7974 93.7959 94.5436 92.0817C96.539 90.1226 98.5345 88.0409 100.281 85.7145C101.528 84.1226 102.65 82.5307 103.648 80.8165C104.271 80.0817 104.396 79.2244 104.022 78.4899Z",
    fill: "#E1E1E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhoto);
export default __webpack_public_path__ + "static/media/user-photo.8db0a9172d3269cb3fce821c9ff2c0ea.svg";
export { ForwardRef as ReactComponent };